import { MerchantDetail } from 'lib/shop/types';
import React from 'react';

export default function MerchantDescription({
  merchant,
}: {
  merchant: MerchantDetail;
}) {
  return (
    <>
      {(merchant.short_description || merchant.description) && (
        <div>
          {merchant.short_description && (
            <div className="my-2">
              <h3>{merchant.short_description}</h3>
            </div>
          )}
          {merchant.description && (
            <div className="my-2 pb-4">
              <p className="p3">{merchant.description}</p>
            </div>
          )}
          <div className="py-5">
            <div className="h-px w-full border-t border-gray-300"></div>
          </div>
        </div>
      )}
    </>
  );
}
